export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

const initialState = {
  location: null,
  prevUrl: null,
};

export default function routerReducer(state = initialState, { type, payload } = {}) {
  if (type === LOCATION_CHANGE) {
    return {
      ...state,
      prevUrl: state.location ? state.location.pathname.toLowerCase() : null,
      location: payload,
    };
  }
  return state;
}
